import { render, staticRenderFns } from "./StatJudgeCategory.vue?vue&type=template&id=98ec19d2&scoped=true&lang=pug&"
import script from "./StatJudgeCategory.vue?vue&type=script&lang=js&"
export * from "./StatJudgeCategory.vue?vue&type=script&lang=js&"
import style0 from "./StatJudgeCategory.vue?vue&type=style&index=0&id=98ec19d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ec19d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VIcon,VSimpleTable})
